import Tooltip from 'components/Tooltip';
import { PlacementWithLogical, useTheme, Box } from '@chakra-ui/react';
import { Fragment } from 'react';
import StyledPercent from './StyledPercent';
import StyledInfoContainer from './StyledInfoContainer';
import StyledPercentContainer from './StyledPercentContainer';
import StyledBarPercent from './StyledBarPercent';

const BenchMark = ({
  colorPositive,
  colorNegative,
  colorCentralBar,
  fontFamily,
  fontSize = '14px',
  percent,
  tooltipText,
  tooltipId,
  tooltipPlace = 'bottom',
  dataTestId,
  tooltipProps = {},
  maxValue
}) => {
  const theme = useTheme();

  const checkNumber = (number: number) =>
    Math.abs(number) > 0 && Math.abs(number) < 1;

  const WrapperComponent = tooltipId ? Tooltip : Fragment;
  const wrapperComponentProps = tooltipId
    ? {
        label: tooltipText,
        dataTestId: tooltipId,
        placement: tooltipPlace as PlacementWithLogical,
        bg: theme.colors?.white,
        ...tooltipProps
      }
    : {};

  return (
    <WrapperComponent {...wrapperComponentProps}>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        width='100%'
      >
        <StyledPercentContainer
          dataTestId={dataTestId || 'cjtable-cell-benchmark-id'}
        >
          {percent <= 0 && (
            <StyledInfoContainer>
              <StyledPercent
                fontSize={fontSize}
                fontFamily={fontFamily}
                colorPositive={colorPositive}
                dataTestId='cjtable-cell-benchmark-percent'
              >
                {`${checkNumber(percent) ? '<' : ''}${
                  percent !== 0 ? '-' : ''
                }${Math.floor(Math.abs(percent))}%`}
              </StyledPercent>
              <StyledBarPercent
                colorPositive={colorPositive}
                dataTestId='cjtable-cell-negative-benchmark-bar'
                percent={Math.floor(Math.abs(percent))}
                isNegative
              />
            </StyledInfoContainer>
          )}
        </StyledPercentContainer>
        <Box
          height='33px'
          width='0px'
          backgroundColor={colorCentralBar}
          position='relative'
          border={`0.5px solid ${theme.colors.lightGrey}`}
        >
          {percent === 0 && (
            <StyledBarPercent
              colorPositive={colorPositive}
              dataTestId='cjtable-cell-benchmark-zero-percent-bar'
              bgColor={theme.colors.green}
              percent={3}
              isZeroPercent
            />
          )}
        </Box>
        <StyledPercentContainer>
          {percent > 0 && (
            <StyledInfoContainer>
              <StyledBarPercent
                colorPositive={colorPositive}
                dataTestId='cjtable-cell-positive-benchmark-bar'
                bgColor={colorNegative || theme.colors.red}
                percent={Math.floor(percent)}
              />
              <StyledPercent
                colorPositive={colorPositive}
                dataTestId='cjtable-cell-benchmark-percent'
                fontSize={fontSize}
                fontFamily={fontFamily}
                color={colorNegative || theme.colors.red}
              >
                {maxValue && percent >= maxValue ? (
                  <>
                    <Box
                      as='span'
                      fontSize='10px'
                      fontFamily={theme.fonts.regular}
                      color={theme.colors.mediumGrey2}
                      margin='0 5px 0 0'
                    >
                      [Over]
                    </Box>
                    +{maxValue}%
                  </>
                ) : (
                  `+${Math.floor(percent)}% ${checkNumber(percent) ? '>' : ''}`
                )}
              </StyledPercent>
            </StyledInfoContainer>
          )}
        </StyledPercentContainer>
      </Box>
    </WrapperComponent>
  );
};

export default BenchMark;
